export const VARIATION_CREATE_REQUEST = 'VARIATION_CREATE_REQUEST';
export const VARIATION_CREATE_SUCCESS = 'VARIATION_CREATE_SUCCESS';
export const VARIATION_CREATE_FAIL = 'VARIATION_CREATE_FAIL';

export const VARIATION_DELETE_REQUEST = 'VARIATION_DELETE_REQUEST';
export const VARIATION_DELETE_SUCCESS = 'VARIATION_DELETE_SUCCESS';
export const VARIATION_DELETE_FAIL = 'VARIATION_DELETE_FAIL';

export const VARIATION_UPDATE_REQUEST = 'VARIATION_UPDATE_REQUEST';
export const VARIATION_UPDATE_SUCCESS = 'VARIATION_UPDATE_SUCCESS';
export const VARIATION_UPDATE_FAIL = 'VARIATION_UPDATE_FAIL';

export const VARIATION_IMAGE_DELETE_REQUEST = 'VARIATION_IMAGE_DELETE_REQUEST';
export const VARIATION_IMAGE_DELETE_SUCCESS = 'VARIATION_IMAGE_DELETE_SUCCESS';
export const VARIATION_IMAGE_DELETE_FAIL = 'VARIATION_IMAGE_DELETE_FAIL';

export const SINGLE_VARIATION_CREATE_REQUEST =
  'SINGLE_VARIATION_CREATE_REQUEST';
export const SINGLE_VARIATION_CREATE_SUCCESS =
  'SINGLE_VARIATION_CREATE_SUCCESS';
export const SINGLE_VARIATION_CREATE_FAIL = 'SINGLE_VARIATION_CREATE_FAIL';

export const VARIATION_IMAGE_REQUEST = 'VARIATION_IMAGE_REQUEST';
export const VARIATION_IMAGE_SUCCESS = 'VARIATION_IMAGE_SUCCESS';
export const VARIATION_IMAGE_FAIL = 'VARIATION_IMAGE_FAIL';
